const spec = {
  maputnik: {
    maptiler_access_token: {
      label: "MapTiler Access Token",
      doc: "Public access token for MapTiler Cloud."
    },
    thunderforest_access_token: {
      label: "Thunderforest Access Token",
      doc: "Public access token for Thunderforest services."
    },
    style_renderer: {
      label: "Style Renderer",
      doc: "Choose the default Maputnik renderer for this style.",
    },
  }
}

export default spec;
